import Header from './shared/Header';
import StratusRoutes from './Routes';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'react-toastify/dist/ReactToastify.min.css';
import { GlobalContextProvider } from './GlobalContextProvider';
import { ToastContainer } from 'react-toastify';
import { MsalProvider } from '@azure/msal-react';
import { IPublicClientApplication } from '@azure/msal-browser';

type AppProps = {
  instance: IPublicClientApplication;
};

function App({ instance }: AppProps) {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnMount: false,
        // don't enable retrying
        staleTime: Infinity,
        gcTime: Infinity,
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchIntervalInBackground: false,
      },
    },
  });

  console.log('App rendered');

  return (
    <MsalProvider instance={instance}>
      <BrowserRouter>
        <GlobalContextProvider>
          <QueryClientProvider client={queryClient}>
            <Header />
            <main className="main-content">
              <ToastContainer closeOnClick={false} />
              <StratusRoutes />
              {/* <EventsList /> */}
            </main>
          </QueryClientProvider>
        </GlobalContextProvider>
      </BrowserRouter>
    </MsalProvider>
  );
}

export default App;
